import React from 'react';
import ReactDOM from 'react-dom/client';
import '../Common.style.css';
import { Provider } from 'react-redux';

import App from './App';
import Store from '../Redux/Store';
import { checkAuth } from '../Redux/Reducers/SuperAdminAuth.Reducer';
import { HelmetProvider } from 'react-helmet-async';

Store.dispatch(checkAuth());
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <Provider store={Store}>
        <HelmetProvider>
            <App />
        </HelmetProvider>
    </Provider>
);
